import {
  IPurchaseTransactionExtendedData,
  isPurchaseTransactionExtendedData,
  TransactionType,
} from '@principle-theorem/principle-core/interfaces';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import {
  ITransactionAction,
  ITransactionActionsData,
} from '../../../transaction-action';
import {
  getRefundInfo$,
  getRefundLabel$,
  getRefundRemaining$,
} from '../../../transaction-helpers';
import { TyroPurchaseTransactionProvider } from '../tyro-purchase-transaction-provider.service';

export class RefundTyroPurchaseTransaction
  implements ITransactionAction<IPurchaseTransactionExtendedData>
{
  icon = 'undo';
  label = 'Refund';
  inProgress$ = new BehaviorSubject<boolean>(false);
  typeGuardFn = isPurchaseTransactionExtendedData;

  constructor(private _provider: TyroPurchaseTransactionProvider) {}

  canDo$(
    data: ITransactionActionsData<IPurchaseTransactionExtendedData>
  ): Observable<boolean> {
    return getRefundRemaining$(data).pipe(
      map((remaining) => {
        const isIncoming = data.transaction.type === TransactionType.Incoming;
        const hasRemaining = remaining > 0;
        return isIncoming && hasRemaining;
      })
    );
  }

  label$(
    data: ITransactionActionsData<IPurchaseTransactionExtendedData>
  ): Observable<string> {
    return getRefundLabel$(data);
  }

  info$(
    data: ITransactionActionsData<IPurchaseTransactionExtendedData>
  ): Observable<string[]> {
    return getRefundInfo$(data);
  }

  async do(
    data: ITransactionActionsData<IPurchaseTransactionExtendedData>
  ): Promise<void> {
    this.inProgress$.next(true);
    await this._provider.refundTransaction(
      data.invoice,
      data.latestTransaction
    );
    this.inProgress$.next(false);
  }
}
